import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";
import Utils from "../../utils/miscUtils";
import StyledTooltip from "../../utils/styledToolTip";
import { CAPES_PERCENTAGE_AND_MINS_PER_WEEK, MORBIDITY_RELATIVE_RISK_REDUCTION_TITLE, APPLICABLE_AGE_MAX_TITLE, APPLICABLE_AGE_MIN_TITLE, REFERENCE_VOLUME_TITLE, SOURCE_TITLE} from "../../utils/tooltipConstants";

export default function ChangeParametersDialog({
  open, onClose, onSave,
  newAdditionalInputs, setNewAdditionalInputs,
  userInputs,
  advanceErrors, setAdvanceErrors,
  // make dialog fixed-size by default and allow overriding via props
  fixed = true,
  width = "auto",
  height = 1200,
}) {
  
    const [morbidity,setMorbidity] = useState([
        { id: "1", value:newAdditionalInputs.morbidity_risk_reduction[0].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[0].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[0].minutes_per_week},
        { id: "2", value:newAdditionalInputs.morbidity_risk_reduction[1].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[1].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[1].minutes_per_week},
        { id: "3", value:newAdditionalInputs.morbidity_risk_reduction[2].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[2].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[2].minutes_per_week},
        { id: "4", value:newAdditionalInputs.morbidity_risk_reduction[3].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[3].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[3].minutes_per_week},
        { id: "5", value:newAdditionalInputs.morbidity_risk_reduction[4].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[4].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[4].minutes_per_week},
        { id: "6", value:newAdditionalInputs.morbidity_risk_reduction[5].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[5].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[5].minutes_per_week},
        { id: "7", value:newAdditionalInputs.morbidity_risk_reduction[6].data_type + " (*)", value2:newAdditionalInputs.morbidity_risk_reduction[6].risk_reduction_percentage,
        value3:newAdditionalInputs.morbidity_risk_reduction[6].minutes_per_week}
    ]);
    const [physicalBenefitsParams,setPhysicalBenefitsParams] = useState([
        { id: "1", mode:newAdditionalInputs.physical_benefits_params[0].mode, applicableAgeMin: newAdditionalInputs.physical_benefits_params[0].applicable_age_min, 
        applicableAgeMax:newAdditionalInputs.physical_benefits_params[0].applicable_age_max, relativeRisk:newAdditionalInputs.physical_benefits_params[0].relative_risk,
        referenceVolume:newAdditionalInputs.physical_benefits_params[0].reference_volume, capsPercentage: newAdditionalInputs.physical_benefits_params[0].caps_percentage,
        capsMinOrWeek: newAdditionalInputs.physical_benefits_params[0].caps_min_or_week },
        { id: "2", mode:newAdditionalInputs.physical_benefits_params[1].mode, applicableAgeMin: newAdditionalInputs.physical_benefits_params[1].applicable_age_min, 
        applicableAgeMax:newAdditionalInputs.physical_benefits_params[1].applicable_age_max, relativeRisk:newAdditionalInputs.physical_benefits_params[1].relative_risk,
        referenceVolume:newAdditionalInputs.physical_benefits_params[1].reference_volume, capsPercentage: newAdditionalInputs.physical_benefits_params[1].caps_percentage,
        capsMinOrWeek: newAdditionalInputs.physical_benefits_params[1].caps_min_or_week }
    ]);
    
  // prevent closing by backdrop click or escape when fixed
  const handleDialogClose = (event, reason) => {
    if (fixed && (reason === "backdropClick" || reason === "escapeKeyDown")) return;
    onClose && onClose(event, reason);
  };

  const handleMinPerWeekChange = (returnedId, textValue) =>{
    textValue = validateEmptyFields(textValue)
    const index = returnedId-1
    let temp = newAdditionalInputs;
    let tempMorbidity = [...morbidity]
    temp.morbidity_risk_reduction[index].minutes_per_week=textValue;
    tempMorbidity[index].value3 = textValue
    verifyFieldName(textValue, index, temp)
    setMorbidity(tempMorbidity)
    setNewAdditionalInputs(temp)
  }
  const validateEmptyFields = (textValue) =>{
    if(textValue=='' || textValue==undefined){
      return textValue = 0;
    }
    return parseFloat(textValue);
  }
  const verifyFieldName = (textValue, index, temp) =>{
      let errorName = findErrorName(index);
      if(!(Utils.ValidateErrors(textValue, errorName, advanceErrors, setAdvanceErrors))){
      Utils.VerifyFields(temp, userInputs, advanceErrors, setAdvanceErrors, false,[])
      }
  }
  const findErrorName = (index) => {
    let errorName = "";
    switch(index){
      case (0):
        errorName = "conorary_heart_disease_error";
        break;
      case (1):
        errorName = "stroke_error";
        break;
      case(2):
        errorName = "dementia_error";
        break;
      case(3):
        errorName = "diabetes_error";
        break;
      case(4):
        errorName = "depression_error";
        break;
      case(5):
        errorName = "breast_cancer_error";
        break;
      case(6):
        errorName = "colon_cancer_error";
        break;
    }
    return errorName;
  }

  useEffect(() => {
    if (open) {
      
    }
  }, []);

  const handleSave = () => {
   
    onClose && onClose(null, "saved");
  };
  const handleRiskReductionChange = (returnedId, textValue) =>{
    textValue = validateEmptyFields(textValue)
    const index = returnedId-1
    let temp = newAdditionalInputs;
    let tempMorbidity = [...morbidity]
    temp.morbidity_risk_reduction[index].risk_reduction_percentage=textValue;
    tempMorbidity[index].value2 = textValue
    setMorbidity(tempMorbidity)
    setNewAdditionalInputs(temp)
  }
  const handleApplicableAgeMinChange = (id, textValue) =>{
    textValue = validateEmptyFields(textValue)
    let temp = newAdditionalInputs;
    let tempPhysicalBenefits = [... physicalBenefitsParams]
    switch (id) {
      case "1":
        temp.physical_benefits_params[0].applicable_age_min=textValue;
        tempPhysicalBenefits[0].applicableAgeMin = textValue
        break;
      case "2":
        temp.physical_benefits_params[1].applicable_age_min=textValue;
        tempPhysicalBenefits[1].applicableAgeMin = textValue
        break;
      default:
        break;
    }
    setNewAdditionalInputs(temp)
    setPhysicalBenefitsParams(tempPhysicalBenefits)
  }
  const handleRelativeRiskChange = (id, textValue) =>{
    textValue = validateEmptyFields(textValue)
    let temp = newAdditionalInputs;
    let tempPhysicalBenefits = [... physicalBenefitsParams]
    switch (id) {
      case "1":
        temp.physical_benefits_params[0].relative_risk=textValue;
        tempPhysicalBenefits[0].relativeRisk = textValue
        break;
      case "2":
        temp.physical_benefits_params[1].relative_risk=textValue;
        tempPhysicalBenefits[1].relativeRisk = textValue
        break;
      default:
        break;
    }
    setNewAdditionalInputs(temp)
    setPhysicalBenefitsParams(tempPhysicalBenefits)
  }
  const handleApplicableAgeMaxChange = (id, textValue) =>{
      textValue = validateEmptyFields(textValue)
      let temp = newAdditionalInputs;
      let tempPhysicalBenefits = [... physicalBenefitsParams]
      switch (id) {
        case "1":
          temp.physical_benefits_params[0].applicable_age_max=textValue;
          tempPhysicalBenefits[0].applicableAgeMax = textValue
          break;
        case "2":
          temp.physical_benefits_params[1].applicable_age_max=textValue;
          tempPhysicalBenefits[1].applicableAgeMax = textValue
          break;
        default:
          break;
      }
      setNewAdditionalInputs(temp)
      setPhysicalBenefitsParams(tempPhysicalBenefits)
    }
    
    const handleReferenceVolumeChange = (id, textValue) =>{
      textValue = validateEmptyFields(textValue)
      let temp = newAdditionalInputs;
      let tempPhysicalBenefits = [... physicalBenefitsParams]
      switch (id) {
        case "1":
          temp.physical_benefits_params[0].reference_volume=textValue;
          tempPhysicalBenefits[0].referenceVolume = textValue
          break;
        case "2":
          temp.physical_benefits_params[1].reference_volume=textValue;
          tempPhysicalBenefits[1].referenceVolume = textValue
          break;
        default:
          break;
      }
  
      if(!(Utils.ValidateErrors(textValue, findReferenceType(id), advanceErrors, setAdvanceErrors))){
        Utils.VerifyFields(temp, userInputs, advanceErrors, setAdvanceErrors, false,[])
      }
  
      setNewAdditionalInputs(temp)
      setPhysicalBenefitsParams(tempPhysicalBenefits)
    }
    const findReferenceType = (index) => {
        let errorType = "";
        switch(index){
        case ("1"):
            errorType = "reference_volume_error_cycling";
            break;
        case ("2"):
            errorType = "reference_volume_error_walking";
            break;
        }
        return errorType;
    }
    const handleCapsPercentageChange = (id, textValue) =>{
        textValue = validateEmptyFields(textValue)
        let temp = newAdditionalInputs;
        let tempPhysicalBenefits = [... physicalBenefitsParams]
        switch (id) {
        case "1":
            temp.physical_benefits_params[0].caps_percentage=textValue;
            tempPhysicalBenefits[0].capsPercentage = textValue
            break;
        case "2":
            temp.physical_benefits_params[1].caps_percentage=textValue;
            tempPhysicalBenefits[1].capsPercentage = textValue
            break;
        default:
            break;
        }
        setNewAdditionalInputs(temp)
        setPhysicalBenefitsParams(tempPhysicalBenefits)
    }
    const findReferenceError = (index) =>{
        let errorName = findReferenceType(index)
        return advanceErrors.some((error) => error.errorType===errorName)
    }
    const handleCapsMinOrWeekChange = (id, textValue) =>{
        textValue = validateEmptyFields(textValue)
        let temp = newAdditionalInputs;
        let tempPhysicalBenefits = [... physicalBenefitsParams]
        switch (id) {
        case "1":
            temp.physical_benefits_params[0].caps_min_or_week=textValue;
            tempPhysicalBenefits[0].capsMinOrWeek = textValue
            break;
        case "2":
            temp.physical_benefits_params[1].caps_min_or_week=textValue;
            tempPhysicalBenefits[1].capsMinOrWeek= textValue
            break;
        default:
            break;
        }
        setNewAdditionalInputs(temp)
        setPhysicalBenefitsParams(tempPhysicalBenefits)
    }

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth={false}
      disableEscapeKeyDown={fixed}
      PaperProps={{ sx: { width: width, maxWidth: "none", height: height, maxHeight: "80vh !important" } }}
    >
      <DialogTitle>Change Parameters</DialogTitle>
      <DialogContent>
        <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          <Grid item xs={12} sx={{ textAlign: "left", pl: "5px" }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Morbidity Relative Risk Reduction
            </Typography>
            <Typography variant="h6" sx={{ mb: 2 }}>
              RISK REDUCTION PER 150 MINUTES OF WEEKLY PHYSICAL ACTIVITY
            </Typography>
          </Grid>
          {morbidity.map((data, index) => (
          <React.Fragment key={data.id}>
              <Grid item xs={12} md={6} sx={{ textAlign: "left", pl: { xs: 0, md: 3 } }}>
                <TextField
                  fullWidth
                  margin="dense"
                  id={data.id}
                  label={data.value}
                  value={data.value3}
                  helperText="Minutes/week"
                  type="number"
                  onChange={(e) => handleMinPerWeekChange(data.id, e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  margin="dense"
                  label="Risk Reduction"
                  id={`risk-${data.id}`}
                  value={data.value2}
                  onChange={(e) => handleRiskReductionChange(data.id, e.target.value)}
                  InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                  aria-describedby="outlined-weight-helper-text"
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  type="number"
                  helperText="Percentage"
                />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <div className="py-4">
            <label htmlFor="" className="label-default mb-4">
            Physical Activity Benefit Parameters
            </label>
            <Typography
            className="component_first_subtitle"
            variant="caption"
            gutterBottom
            >
            This page presents the parameters used to calculate health benefits, like the age range and the reduction in relative risk due to increased activity
            </Typography>
            <br></br>
            <TableContainer component={Paper}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell style={{ fontSize: '16px' }}>Mode</TableCell>
                    <TableCell style={{ fontSize: '12px' }}>Applicable Age (min)<StyledTooltip title={APPLICABLE_AGE_MIN_TITLE} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    <TableCell style={{ fontSize: '12px' }}>Applicable Age (max)<StyledTooltip title={APPLICABLE_AGE_MAX_TITLE} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    <TableCell style={{ fontSize: '12px' }}>Relative Risk <StyledTooltip title={MORBIDITY_RELATIVE_RISK_REDUCTION_TITLE} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    <TableCell style={{ fontSize: '12px' }}>Reference Volume  (*)<StyledTooltip title={REFERENCE_VOLUME_TITLE} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    <TableCell style={{ fontSize: '11px' }}>Caps (%improve) <StyledTooltip title={CAPES_PERCENTAGE_AND_MINS_PER_WEEK} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    <TableCell style={{ fontSize: '11px' }}>Caps (min/week) <StyledTooltip title={CAPES_PERCENTAGE_AND_MINS_PER_WEEK} arrow><span className="icon"></span></StyledTooltip></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {physicalBenefitsParams.map((item, index) => (
                    <TableRow key={index}>
                        <TableCell>{item.mode}</TableCell>
                        <TableCell><TextField value={item.applicableAgeMin} 
                        onChange={(e) => handleApplicableAgeMinChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell><TextField value={item.applicableAgeMax} 
                        onChange={(e) => handleApplicableAgeMaxChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell><TextField value={item.relativeRisk} 
                        onChange={(e) => handleRelativeRiskChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell><TextField value={item.referenceVolume} 
                        error={findReferenceError(item.id)}
                        onChange={(e) => handleReferenceVolumeChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell><TextField value={item.capsPercentage} 
                        onChange={(e) => handleCapsPercentageChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell><TextField value={item.capsMinOrWeek}
                        onChange={(e) => handleCapsMinOrWeekChange(item.id,e.target.value)}></TextField></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" sx={{ backgroundColor: "#00aaff" }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
